module.exports = __webpack_public_path__ + "static/media/female.7f3d12a7.svg";